// Author panyurou
// Date 2023-02-23 13:02:15

import * as model from "@/model/sithMes/stool/SithMesStoolExternalInspectionModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolExternalInspection(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
